import { Component, OnInit, ViewChild } from '@angular/core';
import { ServiceProviderService } from '../../Service/Service-providers/service-provider.service';
import { PromotionDashboardTabsComponent } from './promotion-dashboard-tabs/promotion-dashboard-tabs.component';

@Component({
  selector: 'app-promotion-dashboard',
  templateUrl: './promotion-dashboard.component.html',
  styleUrls: ['./promotion-dashboard.component.scss']
})
export class PromotionDashboardComponent implements OnInit {
  promotions: any[] = [];
  previewVisible = false;
  previewFile: any = null;

  actionModalVisible: boolean = false;
  actionReason: string = '';
  selectedActionPromo: any = null;
  isApproveAction: boolean = true;
  isReasonValid: boolean = false;

  submittedCount: number = 0;
  approvedCount: number = 0;
  rejectedCount: number = 0;

  @ViewChild('submittedTab') submittedTab!: PromotionDashboardTabsComponent;
  @ViewChild('approvedTab') approvedTab!: PromotionDashboardTabsComponent;
  @ViewChild('rejectedTab') rejectedTab!: PromotionDashboardTabsComponent;
  activeIndex: number = 0;
  searchText: string = '';
  rangeDates: Date[] = [];

  constructor(private serviceProviderService: ServiceProviderService) { }

  ngOnInit(): void {
    this.fetchInitialData();
  }
  onTabChange(event: any) {
    const selectedIndex = event.index;
    this.activeIndex = selectedIndex;
    this.fetchTabData(selectedIndex);
  }
  // fetchTabData(index: number) {
  //   // Fetch data only for the selected tab
  //   const params = { status: index + 1 };

  //   this.serviceProviderService.getPromotions(params).subscribe((response: any) => {
  //     this.loadTabData(index, response.result?.data, response.result?.recordsFiltered);
  //     console.log(" API Response:", response);
  //   });
  // }
  fetchTabData(index: number) {
  const params = { status: index + 1 };
  this.serviceProviderService.getPromotions(params).subscribe((response: any) => {
    let totalRecords = 0;
    if (index === 0) {
      totalRecords = response.totalSubmittedRecord;
    } else if (index === 1) {
      totalRecords = response.totalApprovedRecord;
    } else if (index === 2) {
      totalRecords = response.totalRejectedRecord;
    }
    this.loadTabData(index, response.result?.data, totalRecords);
    console.log(" API Response:", response);
  });
}
  fetchInitialData(): void {
    // Single API call to fetch both counts and data for the active tab
    const params = { status: this.activeIndex + 1 };  // +1 because activeIndex is 0-based, status is 1-based

    this.serviceProviderService.getPromotions(params).subscribe((res: any) => {
      // Update counts for all tabs
      this.submittedCount = res.totalSubmittedRecord;
      this.approvedCount = res.totalApprovedRecord;
      this.rejectedCount = res.totalRejectedRecord;

      // Load the data into the active tab
        let totalRecords = 0;
        switch (this.activeIndex) {
        case 0:
          totalRecords = res.totalSubmittedRecord;
          break;
        case 1:
          totalRecords = res.totalInReviewedRecord;
          break;
        case 2:
          totalRecords = res.totalApprovedRecord;
          break;
        case 3:
          totalRecords = res.totalRejectedRecord;
          break;
        default:
          totalRecords = res.result.recordsFiltered;
      }
      this.loadTabData(this.activeIndex, res.result.data, totalRecords);
    });
  }
  showLoadMore(index: number): boolean {
    const tabComponent = [this.submittedTab, this.approvedTab, this.rejectedTab][index];
    const count = index === 0 ? this.submittedCount : index === 1 ? this.approvedCount : this.rejectedCount;
    return tabComponent?.promotions.length < count;
  }
  loadTabData(index: number, data: any[], totalRecords: number) {
    switch (index) {
      case 0:
        this.submittedTab?.setData(data, totalRecords);
        break;
      case 1:
        this.approvedTab?.setData(data, totalRecords);
        break;
      case 2:
        this.rejectedTab?.setData(data, totalRecords);
        break;
      default:
        break;
    }
  }
  updateList(): void {
    this.fetchInitialData(); // Re-fetch data after an update
  }


  openPreview(file: any): void {
    this.previewFile = file;
    this.previewVisible = true;
  }
  shouldShowImage(fileName?: string): boolean {
    if (typeof fileName !== 'string') return false;

    const ext = fileName.split('.').pop()?.toLowerCase();
    return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext || '');
  }
  isPdf(url: string): boolean {
    return url?.toLowerCase().endsWith('.pdf');
  }

  openActionModal(promo: any, isApprove: boolean): void {
    this.selectedActionPromo = promo;
    this.isApproveAction = isApprove;
    this.actionReason = '';
    this.actionModalVisible = true;
    console.log(this.selectedActionPromo.promotionId)

  }

  submitAction(): void {
    const status = this.isApproveAction ? 2 : 3;
    const message = this.actionReason.trim();
    console.log(this.selectedActionPromo.promotionId)
    if (!this.selectedActionPromo) return;

    this.serviceProviderService.reviewPromotion(this.selectedActionPromo.promotionId, status, message).subscribe({
      next: () => {
        this.actionModalVisible = false;
        this.fetchInitialData(); // refresh list
      },
      error: err => console.error("Action failed", err)
    });
  }

  isValidReason(): boolean {
    return this.isReasonValid;
  }

  onReasonChange(reason: string): void {
    const words = reason.trim().split(/\s+/).filter(word => word.length > 0);
    // this.isReasonValid = words.length >= 15;
  }
}
